import { Component, Directive, EventEmitter, HostBinding, Input, Output } from "@angular/core";
import { Product } from "@brain/models";

@Directive({
    selector: "[brainHideIfFiltered]",
})
export class BrainCatalogHideIfFilteredDirective {

  public static DISPLAY_MODE = {
      NONE: "none",
      BLOCK: "block"
  };

  @HostBinding("style.display")
  public display = BrainCatalogHideIfFilteredDirective.DISPLAY_MODE.BLOCK;

  public hide(): void {
      this.display = BrainCatalogHideIfFilteredDirective.DISPLAY_MODE.NONE;
  }

  public show(): void {
      this.display = BrainCatalogHideIfFilteredDirective.DISPLAY_MODE.BLOCK;
  }
}

@Component({
    selector: "brain-catalog-filter",
    templateUrl: "./filter.html",
    styleUrls: ["./filter.scss"]
})
export class BrainCatalogFilterComponent {

  @Input()
  public filterSuggestions: string[] = [];

  @Input()
  public set products(products: Product[]) {
      if (!this.source) {
          this.source = [...products];
      }

      this.filterSuggestions = this.extractTags(this.source);
      this.filterItems = [...products];
  }

  @Output()
  filterChange: EventEmitter<Product[]> = new EventEmitter();

  public filters: string[] = [];

  public isFiltered = false;

  private filterItems: Product[];

  private source: Product[];

  /**
   * filter has been changed
   *
   */
  public onFilterChanged(filters: string[]): void {

      if (filters.length === 0) {
          this.filterItems       = [...this.source];
          this.filterSuggestions = this.extractTags(this.filterItems);
          this.isFiltered        = false;
          this.filterChange.next(this.filterItems);
          return;
      }

      const sourceItems = this.filters.length < filters.length ? this.source : this.filterItems;
      const filtered = sourceItems.filter((product) => {
          return filters.every((item) => {
              const required = item.toLowerCase();
              let isMatch = product.tags.some((tag) => tag.toLowerCase().indexOf(required) > -1);
              isMatch = isMatch || product.name?.toLowerCase().indexOf(required) > -1;
              isMatch = isMatch || product.short_description?.toLowerCase().indexOf(required) > -1;
              return isMatch;
          });
      });

      this.filterSuggestions = this.extractTags(filtered);
      this.filterItems       = filtered;
      this.isFiltered        = true;

      this.filterChange.next(this.filterItems);
  }

  /**
   * get all tags from existing products
   *
   */
  private extractTags(products: Product[]) {

      const tags = products.reduce<string[]>((data: string[],  product: Product) => {
          return data.concat(...(product?.tags.map((tag) => tag.trim()) ?? []));
      }, []);

      return Array.from(new Set(tags));
  }
}
